import { NAME_SPACE } from './constants'
import { 
   getSubjectListApi,
   updateSubjectItemApi, 
   changeSubjectItemStatusApi, 
   getHistoriesVersionsApi,
   updateQualificationApi,
   getQualificationListApi,
   changeQualificationItemStatusApi
  } from './service'
const initData = () => ({
    subjects:[],
    historiesVersionsList: [],
    qualificationList: [],
    loading:{
        getSubjectsLoading: false,
        getHistoriesVersionsLoading:false,
        updateSubjectItemLoading:false,
        changeSubjectItemStatusLoading:false,
        updateQualificationLoading:false,
        getQualificationListLoading:false,
        changeQualificationItemStatusLoading:false
    },
})
const model = {
    name: NAME_SPACE,
    namespaced: true,
    state: initData(),
    mutations: {
      setStateLevel0(state, {key, value}) {
        state[key] = value
      },
      setLoading(state, {key, value}) {
        state.loading[key] = value
      },
      initData(state) {
        const new_state = initData()
        Object.keys(state).forEach(key => {
          state[key] = new_state[key]
        })
      }
    },
    actions: {
        // 获取主体列表
        async getSubjectList({ commit }, { updateSelect, call } = {}) {
            commit('setLoading', { key:'getSubjectsLoading', value:true })
            const result = await getSubjectListApi({
                final() {
                    commit('setLoading', { key:'getSubjectsLoading', value:false })
                }
            })
            commit('setStateLevel0', { key:'subjects', value:(result && result.subjects) || [] })
            if (call) {
              call((result && result.subjects) || [])
            }
            if (updateSelect) {
              updateSelect((result && result.subjects) || [])
            }
          },
        // 新建或更新主体
        async updateSubjectItem({ commit, dispatch }, { call:success, updateSelect, ...params }) {
          commit('setLoading', { key:'updateSubjectItemLoading', value:true })
          await updateSubjectItemApi({
            ...params,
            final() {
                commit('setLoading', { key:'updateSubjectItemLoading', value:false })
            }
          })
          success()
          dispatch('getSubjectList', { updateSelect })
        },
        // 改变主体的状态
        async changeSubjectItemStatus({ commit, dispatch }, { call:success, updateSelect, ...params }) {
          commit('setLoading', { key:'changeSubjectItemStatusLoading', value:true })
          await changeSubjectItemStatusApi({
            ...params,
            final() {
                commit('setLoading', { key:'changeSubjectItemStatusLoading', value:false })
            }
          })
          success && success()
          dispatch('getSubjectList', { updateSelect })
        },
        // 获取资质列表
        async getQualificationList({ commit }, params) {
          commit('setLoading', { key:'getQualificationListLoading', value:true })
          const result = await getQualificationListApi({
              ...params,
              fail() {
                commit('setStateLevel0', { key:'qualificationList', value:[] })
              },
              final() {
                  commit('setLoading', { key:'getQualificationListLoading', value:false })
              }
          })
          commit('setStateLevel0', { key:'qualificationList', value:(result && result.items) || [] })
        },
        // 获取资质历史版本
        async getHistoriesVersions({ commit }, {fail:failCall, ...params}) {
          commit('setLoading', { key:'getHistoriesVersionsLoading', value:true })
          const result = await getHistoriesVersionsApi({
              ...params,
              fail() {
                failCall()
                commit('setStateLevel0', { key:'historiesVersionsList', value:[] })
              },
              final() {
                  commit('setLoading', { key:'getHistoriesVersionsLoading', value:false })
              }
          })
          commit('setStateLevel0', { key:'historiesVersionsList', value:(result && result.versions) || [] })
        },
        // 新增编辑资质
        async updateQualification({ commit, dispatch }, {s_params, subject_id}) {
          const {call:success, ...s_other_params} = s_params
          commit('setLoading', { key:'updateQualificationLoading', value:true })
          const formData = new FormData();
          const isEdit = !!s_other_params.id
          Object.keys(s_other_params).forEach(key => {
            if ([null, '', undefined].includes(s_other_params[key])) {
              return
            }
            formData.append(key, s_other_params[key])
          })
          await updateQualificationApi({
            isEdit,
            formData,
            final() {
              commit('setLoading', { key:'updateQualificationLoading', value:false })
            }
          })
          success && success()
          dispatch('getQualificationList', { subject_id })
        },
        // 修改资质条目状态
        async changeQualificationItemStatus({ commit, dispatch }, {call:success, subject_id, ...params}) {
          commit('setLoading', { key:'changeQualificationItemStatusLoading', value:true })
          await changeQualificationItemStatusApi({
            ...params,
            final() {
                commit('setLoading', { key:'changeQualificationItemStatusLoading', value:false })
            }
          })
          success && success()
          dispatch('getQualificationList', { subject_id })
        }
    }
  };
  
  export default model;
  